import { ZoneMasterThemeModeConfig } from './types';

const dark: ZoneMasterThemeModeConfig = {
  zoneMaster: {},
};

export default dark;
